import { DestinationDistance } from "pages/api/distance-search";
import Image from "next/legacy/image";

import DistanceCalculator from "components/vacancies/VacancyOverview/DistanceCalculator";

import {
    OverviewHero,
    OverviewHeroImage,
    Title,
    TitleAndDistanceCalculator
} from "./VacancyOverviewHero.styled";

import { useMediaQueryContext } from "helpers/hooks";

export function VacancyOverviewHero({
    regions,
    setDestinationsWithDistances,
    queryHasBeenMade
}: {
    regions: Array<string>;
    setDestinationsWithDistances: (
        value: Array<DestinationDistance> | undefined
    ) => void;
    queryHasBeenMade: boolean;
}): JSX.Element {
    const { isTabletViewOrLarger } = useMediaQueryContext();

    return (
        <OverviewHero>
            <OverviewHeroImage>
                <Image
                    src="/images/vacancy-hero.webp"
                    priority
                    loading="eager"
                    alt="Vacancies banner"
                    layout="responsive"
                    width={264}
                    height={186}
                />
            </OverviewHeroImage>

            <TitleAndDistanceCalculator>
                <Title>Uitdagingen voor jou</Title>

                {isTabletViewOrLarger && (
                    <DistanceCalculator
                        regions={regions}
                        setDestinationsWithDistances={
                            setDestinationsWithDistances
                        }
                        queryHasBeenMade={queryHasBeenMade}
                    />
                )}
            </TitleAndDistanceCalculator>
        </OverviewHero>
    );
}
